import { CreateInvoiceDTO } from '../../components/invoice/invoice.type';
import { LimitedReportInvoiceDTO } from '../../components/monitoring-reports/limited-report/limited-report.type';
import logoBase64 from '../../assets/img/logo_with_text_base64';

export const createInvoicesSummaryContent = (
  currentInvoice: LimitedReportInvoiceDTO,
  pastInvoices: LimitedReportInvoiceDTO[],
  currentInvoiceData: CreateInvoiceDTO,
): any[] => {
  const today = new Date();
  const invoiceDate = currentInvoice.invoice?.invoiceDate ? new Date(currentInvoice.invoice.invoiceDate) : today;
  const invoiceDateDisplay = invoiceDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const projectAddressString = [
    currentInvoiceData.projectAddress?.street,
    currentInvoiceData.projectAddress?.city,
    currentInvoiceData.projectAddress?.state,
    currentInvoiceData.projectAddress?.postalCode,
  ]
    .filter(Boolean)
    .join(', ');

  const allInvoices = [currentInvoice, ...pastInvoices];

  return [
    // Header with logo and company info
    {
      stack: [
        // Logo image
        {
          image: logoBase64,
          width: 110,
          alignment: 'center',
          margin: [0, 0, 0, 5],
        },
      ],
      margin: [0, 5, 0, 20],
    },

    // Main title
    {
      text: 'INVOICE SUMMARY:',
      style: 'invoiceTitle',
      margin: [0, 0, 0, 15],
    },
    {
      text: `${invoiceDateDisplay}`,
      margin: [0, 0, 0, 10],
    },
    // Introductory statement
    {
      text: 'Following is a summary of all invoices, including the current invoice, and the status of each.',
      margin: [0, 0, 0, 20],
    },
    // Project Information
    {
      columns: [
        { text: 'Project:', width: 65 },
        {
          stack: [
            { text: `${currentInvoiceData.projectName || ''}`.trim(), bold: true, margin: [0, 0, 0, 3] },
            ...(projectAddressString ? [{ text: projectAddressString, bold: true, margin: [0, 0, 0, 0] }] : []),
          ],
          width: '*',
        },
      ],
      margin: [0, 0, 0, 10],
    },
    {
      table: {
        headerRows: 1,
        widths: ['20%', '20%', '20%', '20%', '20%'],
        body: [
          [
            { text: 'Invoice Number', style: 'tableHeader' },
            { text: 'Invoice Date', style: 'tableHeader' },
            { text: 'Invoice Amount', style: 'tableHeader' },
            { text: 'Paid Amount', style: 'tableHeader' },
            { text: 'Net Owed', style: 'tableHeader' },
          ],
          ...allInvoices.map(invoice => [
            { text: invoice.invoice.number, style: 'tableCell' },
            { text: new Date(invoice.invoice.invoiceDate).toLocaleDateString(), style: 'tableCell' },
            { text: `$${invoice.invoice.invoiceAmount.toLocaleString()}`, style: 'tableCell' },
            { text: `$${invoice.invoice.paidAmount.toLocaleString()}`, style: 'tableCell' },
            { text: `$${(invoice.invoice.invoiceAmount - invoice.invoice.paidAmount).toLocaleString()}`, style: 'tableCell' },
          ]),
          [
            { text: 'Total Balance Due', style: 'tableFooter' },
            { text: '', style: 'tableFooter' },
            { text: '', style: 'tableFooter' },
            { text: '', style: 'tableFooter' },
            {
              text: `$${allInvoices
                .reduce((sum, invoice) => sum + (invoice.invoice.invoiceAmount - invoice.invoice.paidAmount), 0)
                .toLocaleString()}`,
              style: 'tableFooter',
            },
          ],
        ],
      },
      layout: 'noBorders',
    },
    {
      text: 'If any of the above have been paid within the last 10 working days, please ignore the paid invoice.',
      margin: [0, 20, 0, 10],
    },
    {
      text: 'PLEASE PAY ANY BALANCE DUE PROMPTLY, OR CONTACT US WITH ANY QUESTIONS OR CONCERNS',
      margin: [0, 10, 0, 10],
      color: '#0066cc',
    },
  ];
};
